import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';
import {formatDate, formatText, truncate} from '../utils/utils';

import Rendition from '../components/Rendition';

import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewDataSpec from "../components/ViewDataSpec";
import ViewMetadata from "../components/ViewMetadata";

import ListClasses from "../components/ListClasses";
import ListSerializations from "../components/ListSerializations";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewDataSpecVersion from "../components/ViewDataSpecVersion";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import {getDataSpec, addDataSpec, editDataSpec} from '../utils/utilsDataSpec';

import JSZip from "jszip";


class DataSpec extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.loadedClasses = this.loadedClasses.bind(this);
        this.loadedSerializations = this.loadedSerializations.bind(this);


        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);





        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/dataspecs`;


    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        // Handle route/props changes
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadDataSpec(id){

        if (id === undefined || id === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        // Main data spec load
        const onLoad = function(DataSpec) {
            let StateChange = {
                DataSpec: DataSpec,
                isLoaded: true,
                renderState: 'loaded'
            };

            StateChange.FormData = DataSpec;
            StateChange.OfferEdit = false;
            
            if (this.dsd.loggedon){
                if (this.dsd.user.id === DataSpec.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            this.setState(StateChange, () => {
                this.setLayoutContent();

                // Set up breadcrumb navigation
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'dataspec'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['data spec',`/dataspec/${id}`]);

                this.FallBackNavigation = `../dataspecs`;
                this.onUpdateNavigation = this.FallBackNavigation;
            });

        }.bind(this);

        const onFail = function(e) {
            if (e.response){
                if (e.response.status === 403){
                    this.setState({
                        renderState: 'denied',
                        errorMessage: 'Access Denied'
                    });
                } else {
                    this.setState({
                        renderState: 'failed',
                        errorMessage: e.message || 'Failed to load data spec'
                    });
                }
            } else {
                this.setState({
                    renderState: 'failed',
                    errorMessage: e.message || 'Failed to load data spec'
                });
            }
        }.bind(this);

        getDataSpec(this.dsd, id, onLoad, onFail);
        
        return;
        
    };

    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',

            OfferEdit: false,

            FormData: {},
            Controls: {
                vizStructures: false
            },


            countClasses : null,
            countSerializations: null,


            DataSpec: null,

            idVersion: null,

            action: null,

            updateToggle: 0,

            countVersions: null,

            jsonSchema:{}

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idDataSpec = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        // For new mode, set as loaded immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        StateChange.idVersion = getParam('idVersion', this.props);

        this.setState(StateChange, () => {
            if (this.state.idDataSpec && this.state.mode !== 'new'){
                this.loadDataSpec(this.state.idDataSpec);
            }
        });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        switch (FormFieldName){
            case 'vizStructures':
                Controls[FormFieldName] = FormFieldValue;        
                this.setState({"Controls": Controls});
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    


    handleSubmit(event) {

        const onAdd = (idDataSpec) => {
            this.props.navigation(`/dataspec/${idDataSpec}`);
        };

        const onUpdate = () => {
            this.props.navigation(`/dataspec/${this.state.idDataSpec}`);
        };

        const onError = (error) => {
            this.setState({
                isFailed: true,
                renderState: error.status || "error",
                errorMessage: error.errorMessage || 'Failed to save data spec'
            });
        };

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':

                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/dataspec/${this.state.idDataSpec}`);
                        break;
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false,
                    renderState: 'updating'
                })
        
                switch (this.state.mode){
                    case 'new':
                        addDataSpec(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editDataSpec(this.dsd, this.state.idDataSpec, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddClass':
                this.props.navigation(`/dataspec/${this.state.idDataSpec}/class?mode=new`);
                break;
            case 'btnAddSerialization':
                this.props.navigation(`/dataspec/${this.state.idDataSpec}/serialization?mode=new`);
                break;
    
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'concept':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'entity':
                    if (partsVizNodeId.length > 3){
                        switch(partsVizNodeId[2]){
                            case 'structure':
                                this.props.navigation(`/structure/${partsVizNodeId[3]}`);
                                break;
                        }
                    }else{
                        if (partsVizNodeId.length > 1){
                            this.props.navigation(`/entity/${partsVizNodeId[1]}`);
                        }
                    }
                    break;
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    log(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.DataSpec){
            return null;
        }

        let arrLog = [];

        if (!arrLog.length){
            return null;
        }

        return (
            <PD.Table>
                <PD.Thead>
                    <PD.Tr>
                        <PD.Th>on</PD.Th>
                        <PD.Th>what</PD.Th>
                        <PD.Th>name</PD.Th>
                        <PD.Th>change</PD.Th>
                        <PD.Th>description</PD.Th>
                    </PD.Tr>
                </PD.Thead>

                <PD.Tbody>
                    {
                        arrLog.map(
                        (entry, pos) => 
                            {
                                return (
                                    <PD.Tr key={pos}>
                                        <PD.Td>{formatDate(entry.date,'dmy')}</PD.Td>
                                        <PD.Td>{entry.subjectType}</PD.Td>
                                        <PD.Td>
                                            <PD.PdNavLink to={entry.link} >{entry.name}</PD.PdNavLink>
                                        </PD.Td>
                                        <PD.Td>{entry.action}</PD.Td>
                                        <PD.Td>{formatText(truncate(entry.description), 400)}</PD.Td>
                                    </PD.Tr>
                                )
                            }
                        )
                    }
                </PD.Tbody>
            </PD.Table>

        )


    }

    insertLog(array, entry){

        let boolInserted = false;

        let newArray = [];

        for (let pos=0; pos<array.length;pos++){
            if (!boolInserted){
                if (entry.date < array[pos].date){
                    newArray.push(entry);
                    boolInserted = true;
                }
            }
            newArray.push(array[pos]);
        }

        if (!boolInserted){
            newArray.push(entry);
        }

        return newArray;

    }


    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.DataSpec){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idDataSpec} type='dataspec' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idDataSpec}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    loadedClasses(count){

        let StateChange = {};

        StateChange.countClasses = 0;
        if (count){
            StateChange.countClasses = count;
        }

        this.setState(StateChange);

    }

    loadedSerializations(count){

        let StateChange = {};

        StateChange.countSerializations = 0;
        if (count){
            StateChange.countSerializations = count;
        }

        this.setState(StateChange);

    }


    visualise(){
    
        if (!this.state.DataSpec){
            return <Buffering/>;
        }


        try {

            return(
                <div>

                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    setLayoutContent(){

        if (this.context.hasLayout){
            if (this.state.DataSpec){
                this.context.Layout.setLeftAsDataSpec(this.state.DataSpec._id);
            }
        }

        return;

    }



    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }


    render() {

        // Handle loading/error states
        if (this.state.mode === 'view'){
            switch(this.state.renderState){
                case 'loading':
                    return <Buffering />;
                case 'failed':
                    return (
                        <div>
                            <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>
                        </div>
                    );
                case 'denied':
                    return (
                        <div>
                            <PD.ErrorBox>Access Denied</PD.ErrorBox>
                        </div>
                    );
                default:
                    break;
            }
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.isLoaded || this.state.mode === 'new') {

            if (this.state.idVersion){
                return(
                    <ViewDataSpecVersion idDataSpec={this.state.idDataSpec} idVersion={this.state.idVersion}/>
                )
            }

            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Data Spec</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Data Spec</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewDataSpec json={this.state.DataSpec}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.DataSpec){
                        return <div/>
                    }
                    
                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Data Spec:{this.state.DataSpec.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewDataSpec DataSpec={this.state.DataSpec}/>

                            <br/>

                            <PD.Tabs>

                                <div label={<span>Classes({this.state.countClasses === null ? <Buffering/> : this.state.countClasses})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddClass' value='add a new Class' onClick={this.handleButton}/>
                                        }
                                    </div>

                                    <ListClasses filters={{idDataSpec:this.state.idDataSpec, ...this.state.ClassFilters}} onLoad={this.loadedClasses} />

                                </div>

                                <div label={<span>Serializations({this.state.countSerializations === null ? <Buffering/> : this.state.countSerializations})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddSerialization' value='add a new Serialization' onClick={this.handleButton}/>
                                        }
                                    </div>

                                    <ListSerializations filters={{idDataSpec:this.state.idDataSpec, ...this.state.SerializationFilters}} onLoad={this.loadedSerializations} />

                                </div>

                                <div label='Log'>
                                    {this.log()}
                                </div>

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/dataspecs"
                                        id={this.state.idDataSpec}
                                    />
                                </div>

                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.DataSpec} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            };
        };

        return <div />;
    };



};

// Wrap and export
export default function DataSpec_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <DataSpec {...props} navigation={navigation} location={location} params={params} />;
  }
